import{c as r}from"./compare.js";const o=r;var a=(r,a,s)=>o(a,r,s);export{a as r};
